import { PropsWithChildren, useState } from "react";
import { FocusableForm, IFormProps } from "./FocusableForm";
import React from "react";
import { useAuthenticatedApi } from "@hooks";
import { IDataContextProvider } from "@contexts/data/types";

export const AuthenticatedForm: <Values = Record<string, unknown>>(
  props: PropsWithChildren<Omit<IFormProps<Values>, "readyToLoad">> & {
    dataProviderInstance: IDataContextProvider;
  },
) => JSX.Element = ({ dataProviderInstance, ...rest }) => {
  const [readyToLoad, setReadyToLoad] = useState(false);

  useAuthenticatedApi(dataProviderInstance, () => {
    setReadyToLoad(true);
  });
  return <FocusableForm readyToLoad={readyToLoad} {...rest} />;
};
